import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ItemNavBarSearchView: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/plm/Search/ItemAdvanced', { state: { title: 'Seach itemrevisions', fromMenu: false } });
    },[])

    return <></>;
}
export default ItemNavBarSearchView;